var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1831 2.23425H10.6708V1.56592C10.6708 0.719151 9.98194 0.0302734 9.13541 0.0302734H6.58591C5.73842 0.0302734 5.04906 0.719151 5.04906 1.56592V2.23425H2.53752C1.62353 2.23425 0.880005 2.97753 0.880005 3.89128V10.876C0.880005 11.79 1.62353 12.5336 2.53752 12.5336H13.1831C14.0971 12.5336 14.8408 11.79 14.8408 10.876V3.89128C14.8411 2.97753 14.0973 2.23425 13.1831 2.23425ZM6.15406 1.56592C6.15406 1.32848 6.34774 1.13528 6.58591 1.13528H9.13565C9.37285 1.13528 9.56581 1.32848 9.56581 1.56592V2.23425H6.15406V1.56592ZM13.1831 3.33925H2.53752C2.23285 3.33925 1.98501 3.58685 1.98501 3.89128V5.94703H6.99551H8.72581H13.7358V3.89128C13.7358 3.58685 13.488 3.33925 13.1831 3.33925ZM7.21869 7.05228H8.50239V8.25231H7.21869V7.05228ZM2.53752 11.4285H13.1831C13.488 11.4285 13.7361 11.1807 13.7358 10.876V7.05228H9.6074V8.47597C9.6074 8.96198 9.21206 9.35756 8.72581 9.35756H6.99551C6.50926 9.35756 6.11368 8.96198 6.11368 8.47597V7.05228H1.98501V10.876C1.98501 11.1807 2.23285 11.4285 2.53752 11.4285Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.7f2dd889c38a2d75ad7f76f5e92e0d43.svg";
export { ForwardRef as ReactComponent };